import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FormsModule } from '@angular/forms';
import ReasonRejectionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/reason-rejection/reason-rejection.entity';
import LocationOneAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/locations/location-one/location-one.entity';
import LocationTwoAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/locations/location-two/location-two.entity';
import LocationThreeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/locations/location-three/location-three.entity';

@Component({
  selector: 'app-general-filters',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule
  ],
  templateUrl: './general-filters.component.html',
  styleUrls: ['./general-filters.component.scss']
})
export class GeneralFiltersComponent implements OnChanges {
  @Input() form!: FormGroup;

  @Input() countryList: LocationOneAttributes[] = [];
  @Input() departmentList: LocationTwoAttributes[] = [];
  @Input() cityList: LocationThreeAttributes[] = [];
  @Input() rejectionTypeList: ReasonRejectionAttributes[] = [];
  @Input() rejectionTypeById: boolean = false;

  @Input() useSelects: ('country' | 'department' | 'city' | 'rejectionType')[] = ['country', 'department', 'city', 'rejectionType'];

  searchDepartment = '';
  searchCity = '';
  searchRejectionType = '';

  filteredDepartmentList: any[] = [];
  filterdCityList: any[] = [];
  filteredRejectionTypeList: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    this.filteredDepartmentList = [...this.departmentList];
    this.filterdCityList = [...this.cityList];
    this.filteredRejectionTypeList = [...this.rejectionTypeList];

    this.filterDepartment(this.searchDepartment);
    this.filterCity(this.searchCity);
    this.filterRejectionType(this.searchRejectionType);
  }

  getDisplayValue(list: any[], selectedIds: any[], key: string): string {
    if (!selectedIds || selectedIds.length === 0) return '';
    return list
      .filter(item => selectedIds.includes(item._id) || selectedIds.includes(item.id))
      .map(item => item[key])
      .join(', ');
  }

  filterDepartment(term: string) {
    const value = term?.toLowerCase() ?? '';

     if (value === '') {
      this.filteredDepartmentList = this.departmentList;
    } else {
      this.filteredDepartmentList = this.departmentList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }

  filterCity(term: string) {
    const value = term?.toLowerCase() ?? '';

     if (value === '') {
      this.filterdCityList = this.cityList;
    } else {
      this.filterdCityList = this.cityList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }

  filterRejectionType(term: string) {
    const value = term?.toLowerCase() ?? '';

     if (value === '') {
      this.filteredRejectionTypeList = this.rejectionTypeList;
    } else {
      this.filteredRejectionTypeList = this.rejectionTypeList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }
}
